import { buildGrpcClient } from "../../../../../lib/grpc";
import { TaxConfigurationAPIPromiseClient } from "../../../../../gen/witbooking/backoffice/taxconfiguration/v1/taxconfiguration_api_grpc_web_pb";
import {
  GetTaxConfigurationRequest,
  UpdateTaxConfigurationRequest,
} from "../../../../../gen/witbooking/backoffice/taxconfiguration/v1/taxconfiguration_api_pb";
import { TaxConfigurationEntity } from "../domain/taxConfiguration.entity";
import { toDto, toEntity } from "./taxConfiguration.mapper";

const taxConfigurationClient: TaxConfigurationAPIPromiseClient = buildGrpcClient(
  TaxConfigurationAPIPromiseClient
);

export async function getTaxConfiguration(token: string): Promise<TaxConfigurationEntity> {
  const request = new GetTaxConfigurationRequest();
  const response = await taxConfigurationClient.getTaxConfiguration(request, {
    Authorization: `Bearer ${token}`,
  });
  return toEntity(response.getTaxConfiguration()?.toObject()!);
}

export async function updateTaxConfiguration(
  entity: TaxConfigurationEntity,
  token: string
): Promise<void> {
  const request = new UpdateTaxConfigurationRequest();
  request.setTaxConfiguration(toDto(entity));
  await taxConfigurationClient.updateTaxConfiguration(request, {
    Authorization: `Bearer ${token}`,
  });
}
